const PATH = "/items";

const items = [
  // Default weapons - always free for their respective unit types
  {
    name: "Sword",
    image: "/soldier.png",
    description: "Default weapon for Soldier.",
    portraitDescription: "A one-handed black or metal sword.",
    type: "default-weapon",
    usedBy: ["soldier"],
    isDefaultWeapon: true,
    defaultFor: "soldier",
    listPrice: 0,
  },
  {
    name: "Bow",
    image: "/archer.png",
    description: "Default weapon for Archer.",
    portraitDescription:
      "A bow appropriate to the archer's theme, LEGO minifigure scale.",
    type: "default-weapon",
    usedBy: ["archer"],
    isDefaultWeapon: true,
    defaultFor: "archer",
    listPrice: 0,
  },
  {
    name: "Wizard's Hat",
    image: "/wizard.png",
    description: "Default item for Wizard.",
    portraitDescription:
      "A magical hat appropriate to the wizard's theme, LEGO minifigure scale.",
    type: "default-weapon",
    usedBy: ["wizard"],
    isDefaultWeapon: true,
    defaultFor: "wizard",
    listPrice: 0,
  },
  {
    name: "Necromancer Staff",
    image: "/necromancer.png",
    description: "Default weapon for Necromancer.",
    portraitDescription:
      "A darkened staff or wand-like staff appropriate to a necromancer's theme, LEGO minifigure scale.",
    type: "default-weapon",
    usedBy: ["necromancer"],
    isDefaultWeapon: true,
    defaultFor: "necromancer",
    listPrice: 0,
  },
  {
    name: "Battle Standard",
    image: "/flagbearer.png",
    description: "Default item for Flagbearer.",
    portraitDescription:
      "A flag on a pole (battle standard) sized for a minifigure, with simple heraldry and no text.",
    type: "default-weapon",
    usedBy: ["flagbearer"],
    isDefaultWeapon: true,
    defaultFor: "flagbearer",
    listPrice: 0,
  },
  {
    name: "Bomb",
    image: "/kamikaze.png",
    description: "Default weapon for Kamikaze.",
    portraitDescription:
      "A classic cartoon-style bomb (round black bomb with fuse) or theme-appropriate explosive prop, LEGO minifigure scale.",
    type: "default-weapon",
    usedBy: ["kamikaze"],
    isDefaultWeapon: true,
    defaultFor: "kamikaze",
    listPrice: 0,
  },
  {
    name: "Giant's Axe",
    image: "/giant.png",
    description: "Default weapon for Giant.",
    portraitDescription:
      "A large axe sized for a giant minifigure character, consistent with fantasy LEGO accessories.",
    type: "default-weapon",
    usedBy: ["giant"],
    isDefaultWeapon: true,
    defaultFor: "giant",
    listPrice: 0,
  },
  // Regular items
  {
    name: "Staff of Power",
    image: `${PATH}/staff-of-power.png`,
    description: "Increases spell casting range from 5 to 9.",
    type: "staff",
    usedBy: ["wizard"],
    listPrice: 14,
    benefits: {
      healingDistanceIncrease: 5,
    },
  },
  {
    name: "Staff of Endurance",
    image: `${PATH}/staff-of-endurance.png`,
    description: "Increases max stamina by 25.",
    type: "staff",
    usedBy: ["wizard"],
    listPrice: 15,
    benefits: {
      stamina: 25,
    },
  },
  {
    name: "Shield",
    image: `${PATH}/shield.png`,
    description: "Add +1 to your dodge roll.",
    type: "defense",
    usedBy: ["soldier", "flagbearer", "giant"],
    listPrice: 15,
    benefits: {
      dodgeBonus: 1,
    },
  },
  {
    name: "Helmet",
    image: `${PATH}/helmet-of-dodging.png`,
    description: "Add +1 to your dodge roll.",
    type: "helmet",
    usedBy: ["soldier", "flagbearer", "kamikaze"],
    listPrice: 10,
    benefits: {
      dodgeBonus: 1,
    },
  },
  {
    name: "Crossbow",
    image: `${PATH}/crossbow.png`,
    description: "Increase shooting range from 12 to 19 inches.",
    type: "weapon",
    usedBy: ["archer"],
    listPrice: 11,
    benefits: {
      distanceRollModifier: 1,
    },
  },
  {
    name: "Lethal Arrows",
    image: `${PATH}/lethal-arrows.png`,
    portraitDescription:
      "A quiver of arrows on the back of an archer's minifigure.",
    description: "Increases max damage of arrows by 4.",
    type: "weapon",
    usedBy: ["archer"],
    listPrice: 13,
    benefits: {
      damage: 4,
    },
  },
  {
    name: "Boots of Speed",
    image: `${PATH}/boots.png`,
    description: "+3 movement range. Cannot be used while mounted.",
    type: "boots",
    usedBy: ["soldier", "archer", "wizard"],
    listPrice: 12,
    benefits: {
      range: 3,
    },
  },
  {
    name: "Flail",
    image: `${PATH}/flail.png`,
    description: "Increases attack range by 3 inches.",
    type: "weapon",
    usedBy: ["giant"],
    listPrice: 12,
    benefits: {
      attackRange: 3,
    },
  },
  {
    name: "Ring of Health",
    image: `${PATH}/ring-of-health.png`,
    description: "Increases max health by 10.",
    type: "ring",
    usedBy: ["giant"],
    listPrice: 15,
    benefits: {
      health: 10,
    },
  },
  {
    name: "Spear",
    image: `${PATH}/spear.png`,
    description: "+12 max damage against giants and mounted units.",
    type: "weapon",
    usedBy: ["soldier"],
    requiredUpgrade: "FORTRESS_2",
    listPrice: 13,
    benefits: {
      against: ["giant", "mounted"],
      conditionalDamage: 12,
    },
  },
  {
    name: "Axe",
    image: `${PATH}/axe.png`,
    description: "+12 max damage against archers.",
    type: "weapon",
    usedBy: ["soldier"],
    requiredUpgrade: "FORTRESS_2",
    listPrice: 13,
    benefits: {
      against: ["archer"],
      conditionalDamage: 12,
    },
  },
  {
    name: "Armor",
    image: `${PATH}/armor.png`,
    description: "Reduces damage taken by 5 hit points.",
    type: "armor",
    usedBy: ["soldier", "kamikaze"],
    requiredUpgrade: "FORTRESS_3",
    listPrice: 15,
    benefits: {
      defense: 5,
    },
  },
  {
    name: "Hood",
    image: `${PATH}/hood.png`,
    description: "Reduces damage taken by 3 hit points.",
    type: "helmet",
    usedBy: ["archer"],
    requiredUpgrade: "FORTRESS_2",
    listPrice: 11,
    benefits: {
      defense: 3,
    },
  },
  {
    name: "War Horse",
    image: `${PATH}/warhorse.png`,
    description:
      "Character starts on a horse, which gives twice the movement range.",
    type: "mount",
    usedBy: ["soldier", "archer", "flagbearer", "wizard", "necromancer"],
    listPrice: 35,
    benefits: {
      startsMounted: true,
    },
  },
  {
    name: "Lance",
    image: `${PATH}/lance.png`,
    description: "+10 max damage against ground units.",
    type: "weapon",
    usedBy: [],
    listPrice: 15,
    benefits: {
      against: ["non-mounted"],
      conditionalDamage: 10,
    },
  },
  {
    name: "Hammer",
    image: `${PATH}/hammer.png`,
    description: "+10 max damage against every unit",
    type: "weapon",
    usedBy: [],
    listPrice: 0,
    benefits: {
      damage: 10,
    },
  },
  {
    name: "Balls of Steel",
    image: `${PATH}/balls-of-steel.png`,
    description:
      "Leave combat without a flee roll. Prevent being mind controlled.",
    type: "ring",
    usedBy: ["soldier", "flagbearer", "giant"],
    listPrice: 12,
    ignoreForPortrait: true,
    benefits: {
      canLeaveCombat: true,
    },
  },
];

export default items;
